import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, MapPin, AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
interface LinkInputFormProps {
  link: string;
  setLink: (link: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isProcessing: boolean;
  error: string;
}
const LinkInputForm: React.FC<LinkInputFormProps> = ({
  link,
  setLink,
  onSubmit,
  isProcessing,
  error
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLink(e.target.value);
  };
  const isValidUrl = link.trim() && (link.includes('google.com/maps') || link.includes('maps.app.goo.gl') || link.includes('goo.gl/maps') || link.includes('maps.google.com'));
  return <div className="space-y-4">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-2">
          <div className="flex-1 relative">
            <Input 
              type="url" 
              placeholder="https://maps.app.goo.gl/..." 
              value={link} 
              onChange={handleInputChange} 
              disabled={isProcessing} 
              className={`pr-10 h-12 text-base sm:h-10 sm:text-sm ${error ? 'border-red-300 focus:border-red-500' : ''}`} 
            />
            <MapPin className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 sm:h-4 sm:w-4 text-gray-400" />
          </div>
          <Button 
            type="submit" 
            disabled={isProcessing || !link.trim()} 
            className="h-12 sm:h-10 min-w-[40px] sm:min-w-[80px] text-base sm:text-sm"
          >
            {isProcessing ? <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing
              </> : 'Analyze'}
          </Button>
        </div>
        
        {link.trim() && !isValidUrl && <Alert className="border-amber-200 bg-amber-50">
            <AlertCircle className="h-4 w-4 text-amber-600" />
            <AlertDescription className="text-amber-800">
              Please enter a valid Google Maps URL. You can get this by clicking "Share" on any place in Google Maps.
            </AlertDescription>
          </Alert>}
        
        {error && <Alert className="border-red-200 bg-red-50">
            <AlertCircle className="h-4 w-4 text-red-600" />
            <AlertDescription className="text-red-800">
              {error}
            </AlertDescription>
          </Alert>}
      </form>
      
      <div className="text-xs text-muted-foreground">
        If you have trouble with a link, try using Google Maps' "Share" button to get a direct link.
      </div>
    </div>;
};
export default LinkInputForm;